import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c61f5468"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "color-picker-color-box" }
const _hoisted_3 = { class: "color-picker-color" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"none","border-top":"1px solid #eee","margin-bottom":"9px"} }, null, -1))
const _hoisted_5 = { class: "color-picker-history" }
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = { style: {"border":"none","border-top":"1px solid #eee","margin-top":"2px"} }
const _hoisted_8 = { class: "color-picker-footer" }
const _hoisted_9 = { class: "color-picker-footer-text" }
const _hoisted_10 = { class: "color-picker-footer-text-type" }
const _hoisted_11 = { class: "color-picker-footer-tools" }
const _hoisted_12 = {
  key: 0,
  class: "color-picker-footer-tools-clear"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_color_picker_slider = _resolveComponent("color-picker-slider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["color-picker", `color-picker-${_ctx.size}${_ctx.isShowPicker ? ' active' : ''}`]),
    onMousedown: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.extendPicker && _ctx.extendPicker(...args)), ["stop"]))
  }, [
    _createElementVNode("input", {
      ref: "colorInput",
      class: "color-picker-input",
      type: "text",
      value: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeColor($event)))
    }, null, 40, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "color-picker-color-value",
        style: _normalizeStyle({ 'background-color': _ctx.value })
      }, null, 4)
    ]),
    _createElementVNode("div", {
      ref: "colorPicker",
      class: _normalizeClass(["color-picker-dropdown", { 'color-picker-dropdown-show': _ctx.showPicker, 'color-picker-dropdown-top': _ctx.showPickerTop }]),
      onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", {
        ref: "colorPickerDisk",
        class: "color-picker-disk",
        style: _normalizeStyle({ 'background-color': _ctx.diskBackGround }),
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStartDrag && _ctx.handleStartDrag(...args)))
      }, [
        _createElementVNode("div", {
          class: "color-picker-disk-point",
          style: _normalizeStyle({ transform: `translate(${_ctx.cursorLeft}px, ${_ctx.cursorTop}px)` })
        }, null, 4)
      ], 36),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "color-picker-oldcolor",
          style: _normalizeStyle({ background: _ctx.oldValue })
        }, null, 4),
        _createElementVNode("div", {
          class: "color-picker-newcolor",
          style: _normalizeStyle({ background: _ctx.newValue })
        }, null, 4)
      ]),
      _createVNode(_component_color_picker_slider, {
        value: _ctx.hue,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hue) = $event)),
        max: 360,
        class: "color-picker-slider-disk",
        "slider-style": { background: 'linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)' }
      }, null, 8, ["value", "slider-style"]),
      (_ctx.showAlpha)
        ? (_openBlock(), _createBlock(_component_color_picker_slider, {
            key: 0,
            value: _ctx.alpha,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.alpha) = $event)),
            max: 100,
            class: "color-picker-slider-alpha",
            "slider-style": { background: `linear-gradient(90deg,${_ctx.setAlpha(0)} 0%,${_ctx.setAlpha(1)} 100%)` }
          }, null, 8, ["value", "slider-style"]))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "color-picker-history-item"
          }, [
            _createElementVNode("div", {
              class: "color-picker-history-item-color",
              title: item,
              style: _normalizeStyle({ background: item }),
              onClick: ($event: any) => (_ctx.selectHistoryColor(item))
            }, null, 12, _hoisted_6)
          ]))
        }), 128))
      ]),
      _withDirectives(_createElementVNode("hr", _hoisted_7, null, 512), [
        [_vShow, _ctx.history.length]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newValue) = $event)),
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.newValue]
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.colorType), 1),
          (_ctx.canChangeColorType)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                title: "切换类型",
                class: "color-picker-footer-text-changetype fal fa-exchange",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeColorType && _ctx.changeColorType(...args)))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.canClear)
            ? (_openBlock(), _createElementBlock("button", _hoisted_12, "清空"))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "color-picker-footer-tools-confirm",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.comfirm && _ctx.comfirm(...args)))
          }, "确定")
        ])
      ])
    ], 34)
  ], 34))
}